import { Box, Grid, Skeleton, Stack } from "@mui/material";

// Shown inside the Run Process (Update Brand Data) modal while its support
// data — fetcher config + industry queries — is loading.
const RunBrandDataSkeleton = () => {
  return (
    <Box sx={{ mt: 5 }} data-testid="run-brand-data-skeleton">
      {/* Date pickers */}
      <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
        <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
        <Skeleton variant="rounded" height={40} sx={{ flex: 1 }} />
      </Stack>

      {/* Process options */}
      <Skeleton variant="rounded" width={140} height={18} sx={{ mb: 2 }} />
      <Grid container spacing={3}>
        {Array.from({ length: 6 }).map((_, index) => (
          <Grid item xs={4} key={index}>
            <Stack direction="row" spacing={1} alignItems="center">
              <Skeleton variant="rounded" width={20} height={20} />
              <Skeleton
                variant="rounded"
                height={14}
                animation="wave"
                sx={{ flex: 1 }}
              />
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RunBrandDataSkeleton;
